import React from 'react';
import '../css/Dropdown.css';

/**
 * The dropdown component used in the header
 * @component Dropdown
 * @return {Component} Dropdown component
 */
export default function Dropdown() {
  return (
    <>
      <div href="#/" className="dropdown-block">
        <p>Services</p>
        <div className="dropdown-show-menu">
          <div className="dropdown-spacing" />
          <div className="dropdown-icon">
            <i className="fas fa-certificate"></i>
          </div>
          <div className="dropdown-left-menu">
            <h3>Performance</h3>
            <p>
              AIS Corp. is dedicated to the achievement of superior national
              security through scientific excellence.
            </p>
          </div>
          <div className="dropdown-right-menu">
            <ul>
              <a href="/research">Physics Research</a>
              <br />
              <br />
              <a href="/innovations">Innovations</a>
              <br />
              <br />
              <a href="/products">Product Catalog</a>
              <br />
              <br />
              <a href="/client-login">Client Portal</a>
              <br />
              <br />
            </ul>
          </div>
          <div className="dropdown-right-menu-spacing" />
        </div>
      </div>
      <div href="#/" className="dropdown-block">
        <p>Community</p>
        <div className="dropdown-show-menu">
          <div className="dropdown-spacing" />
          <div className="dropdown-icon">
            <i className="fas fa-users"></i>
          </div>
          <div className="dropdown-left-menu">
            <h3>Maximization</h3>
            <p>
              Discover how AIS fortifies lives, communities, and government.
            </p>
          </div>
          <div className="dropdown-right-menu">
            <ul>
              <a href="/newsroom">Newsroom</a>
              <br />
              <br />
              <a href="/ethics">Ethics</a>
              <br />
              <br />
              <a href="/investor">Investor Relations</a>
              <br />
              <br />
              <a href="/events">Events</a>
              <br />
              <br />
            </ul>
          </div>
          <div className="dropdown-spacing" />
        </div>
      </div>
      <div href="#/" className="dropdown-block">
        <p>Knowledge Base</p>
        <div className="dropdown-show-menu">
          <div className="dropdown-spacing" />
          <div className="dropdown-icon">
            <i className="fas fa-book-open"></i>
          </div>
          <div className="dropdown-left-menu">
            <h3>Information</h3>
            <p>
              Seek real-time answers to America's toughest biodefense
              challenges.
            </p>
          </div>
          <div className="dropdown-right-menu">
            <ul>
              <a href="/faq">FAQ</a>
              <br />
              <br />
              <a href="/encyclopedia">Encyclopedia</a>
              <br />
              <br />
              <a href="/support">Client Services Center</a>
              <br />
              <br />
              <a href="/legal">Legal</a>
              <br />
              <br />
              <hr
                style={{
                  border: '2px',
                  borderTop: '2px solid grey',
                  height: '0px',
                }}
              />
              <br />
              <a href="/coronavirus">
                Coronavirus Update &nbsp;
                <i className="fas fa-virus" style={{fontSize: '16px'}}></i>
              </a>
              <br />
              <br />
            </ul>
          </div>
          <div className="dropdown-spacing" />
        </div>
      </div>
    </>
  );
}
